"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataShareType = void 0;
var DataShareType;
(function (DataShareType) {
    DataShareType["Eligible"] = "eligible";
    DataShareType["Ineligible"] = "ineligible";
    DataShareType["PurchasedLeadsOnly"] = "purchased_leads_only";
})(DataShareType || (exports.DataShareType = DataShareType = {}));
